<template>
    <router-view />
</template>
<style>
#app {
    background: #F1F1F1;
}
</style>
